import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';
import { rootRoutes } from '@routes/root-routes';
import TagManager from 'react-gtm-module';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient();

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID,
};

TagManager.initialize(tagManagerArgs);
// lazy components
const Notification = lazy(() => import('@components/Notification'));

export const router = createBrowserRouter([...rootRoutes], {
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <ThemeProvider theme={brightpathTheme}>
        <CssBaseline />
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <Suspense fallback={null}>
          <Notification />
        </Suspense>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
